// Robust overlay that tracks right-panel bounds using fixed positioning,
// prevents clipping when dialogs change viewport metrics and preserves Bootstrap rotation.

let listenersAttached = false
let ro = null
let rafId = 0

function getElements () {
  const panel = document.getElementById('right-panel')
  const spinner = document.getElementById('spinner')
  return { panel, spinner }
}

function setStyleIfChanged (el, prop, value) {
  if (el.style[prop] !== value) el.style[prop] = value
}

function updateSpinnerRect () {
  const { panel, spinner } = getElements()
  if (!panel || !spinner) return

  const rect = panel.getBoundingClientRect()
  const top = Math.round(rect.top) + 'px'
  const left = Math.round(rect.left) + 'px'
  const width = Math.round(rect.width) + 'px'
  const height = Math.round(rect.height) + 'px'

  // Position as fixed overlay that matches panel bounds (avoids ancestor clipping)
  setStyleIfChanged(spinner, 'position', 'fixed')
  setStyleIfChanged(spinner, 'top', top)
  setStyleIfChanged(spinner, 'left', left)
  setStyleIfChanged(spinner, 'width', width)
  setStyleIfChanged(spinner, 'height', height)
}

function onViewportChange () {
  const { spinner } = getElements()
  if (!spinner || spinner.style.display === 'none') return
  if (rafId) cancelAnimationFrame(rafId)
  rafId = requestAnimationFrame(() => {
    updateSpinnerRect()
    rafId = 0
  })
}

function attachListeners () {
  if (listenersAttached) return
  window.addEventListener('resize', onViewportChange)
  // capture scrolls on any scrollable ancestor
  window.addEventListener('scroll', onViewportChange, true)
  // react to Bootstrap modal show/hide (scrollbar width changes)
  document.addEventListener('shown.bs.modal', onViewportChange, true)
  document.addEventListener('hidden.bs.modal', onViewportChange, true)
  listenersAttached = true

  const { panel } = getElements()
  if (panel && 'ResizeObserver' in window) {
    ro = new ResizeObserver(onViewportChange)
    ro.observe(panel)
  }
}

function detachListeners () {
  if (listenersAttached) {
    window.removeEventListener('resize', onViewportChange)
    window.removeEventListener('scroll', onViewportChange, true)
    document.removeEventListener('shown.bs.modal', onViewportChange, true)
    document.removeEventListener('hidden.bs.modal', onViewportChange, true)
    listenersAttached = false
  }
  if (ro) {
    try { ro.disconnect() } catch (_) {}
    ro = null
  }
}

export function showSpinnerOverlay () {
  const { spinner, panel } = getElements()
  if (!spinner || !panel) return

  // Ensure visible, compute rect and attach listeners
  spinner.style.display = 'flex'
  updateSpinnerRect()
  attachListeners()

  // Double-tick to catch any immediate reflow after file dialogs/modals
  requestAnimationFrame(updateSpinnerRect)
  setTimeout(updateSpinnerRect, 0)
}

export function hideSpinnerOverlay () {
  const { spinner } = getElements()
  if (!spinner) return
  spinner.style.display = 'none'
  spinner.style.position = ''
  spinner.style.top = ''
  spinner.style.left = ''
  spinner.style.width = ''
  spinner.style.height = ''
  detachListeners()
}